/* eslint-disable */
import GraphQL from '../../types/graphql';

import CK from '~/types/contentking';
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RevisionFragment = { readonly __typename?: 'RobotsTxtRevision', readonly createdAt: CK.Timestamp, readonly isContentEmpty: boolean | null, readonly isDownloadAllowed: boolean | null, readonly responseFailureReason: GraphQL.FetchingFailureReason | null, readonly responsePrimaryIp: string | null, readonly responseStatusCode: number | null, readonly url: string, readonly content: { readonly __typename?: 'RobotsTxtRevisionContent', readonly isTooLarge: boolean, readonly longestRowCharacters: number, readonly rows: ReadonlyArray<Record<string, any>> } | null, readonly requestHttpHeaders: ReadonlyArray<{ readonly __typename?: 'HttpHeader', readonly name: string, readonly values: ReadonlyArray<string> }>, readonly responseHttpHeaders: ReadonlyArray<{ readonly __typename?: 'HttpHeader', readonly name: string, readonly values: ReadonlyArray<string> }> | null, readonly searchEngineActivity: ReadonlyArray<{ readonly __typename?: 'SearchEngineActivityAtMoment', readonly lastVisit: CK.Timestamp | null, readonly searchEngine: GraphQL.SearchEngineActivitySearchEngine, readonly status: GraphQL.SearchEngineActivityAtMomentStatus }> | null };

export type RobotsTxtViewerScreenQueryVariables = GraphQL.Exact<{
  getRevisionById: GraphQL.Scalars['Boolean']['input'];
  revisionId: GraphQL.Scalars['ID']['input'];
  websiteId: GraphQL.Scalars['WebsiteId']['input'];
}>;


export type RobotsTxtViewerScreenQuery = { readonly __typename?: 'Query', readonly platformData: { readonly __typename?: 'PlatformData', readonly id: CK.ID, readonly canonicalRobotsTxtLegacyUrlId: number | null } | null, readonly latest: { readonly __typename?: 'RobotsTxtRevision', readonly id: CK.ID, readonly isUnreliable: boolean, readonly lastUnreliableResponse: GraphQL.FetchingFailureReason | null, readonly unreliableSince: CK.Timestamp | null, readonly createdAt: CK.Timestamp, readonly isContentEmpty: boolean | null, readonly isDownloadAllowed: boolean | null, readonly responseFailureReason: GraphQL.FetchingFailureReason | null, readonly responsePrimaryIp: string | null, readonly responseStatusCode: number | null, readonly url: string, readonly content: { readonly __typename?: 'RobotsTxtRevisionContent', readonly isTooLarge: boolean, readonly longestRowCharacters: number, readonly rows: ReadonlyArray<Record<string, any>> } | null, readonly requestHttpHeaders: ReadonlyArray<{ readonly __typename?: 'HttpHeader', readonly name: string, readonly values: ReadonlyArray<string> }>, readonly responseHttpHeaders: ReadonlyArray<{ readonly __typename?: 'HttpHeader', readonly name: string, readonly values: ReadonlyArray<string> }> | null, readonly searchEngineActivity: ReadonlyArray<{ readonly __typename?: 'SearchEngineActivityAtMoment', readonly lastVisit: CK.Timestamp | null, readonly searchEngine: GraphQL.SearchEngineActivitySearchEngine, readonly status: GraphQL.SearchEngineActivityAtMomentStatus }> | null } | null, readonly byId?: { readonly __typename?: 'RobotsTxtRevision', readonly id: CK.ID, readonly createdAt: CK.Timestamp, readonly isContentEmpty: boolean | null, readonly isDownloadAllowed: boolean | null, readonly responseFailureReason: GraphQL.FetchingFailureReason | null, readonly responsePrimaryIp: string | null, readonly responseStatusCode: number | null, readonly url: string, readonly content: { readonly __typename?: 'RobotsTxtRevisionContent', readonly isTooLarge: boolean, readonly longestRowCharacters: number, readonly rows: ReadonlyArray<Record<string, any>> } | null, readonly requestHttpHeaders: ReadonlyArray<{ readonly __typename?: 'HttpHeader', readonly name: string, readonly values: ReadonlyArray<string> }>, readonly responseHttpHeaders: ReadonlyArray<{ readonly __typename?: 'HttpHeader', readonly name: string, readonly values: ReadonlyArray<string> }> | null, readonly searchEngineActivity: ReadonlyArray<{ readonly __typename?: 'SearchEngineActivityAtMoment', readonly lastVisit: CK.Timestamp | null, readonly searchEngine: GraphQL.SearchEngineActivitySearchEngine, readonly status: GraphQL.SearchEngineActivityAtMomentStatus }> | null } | null, readonly list: ReadonlyArray<{ readonly __typename?: 'RobotsTxtRevision', readonly id: CK.ID, readonly createdAt: CK.Timestamp }> | null };

export const RevisionFragmentDoc = gql`
    fragment Revision on RobotsTxtRevision {
  content {
    isTooLarge
    longestRowCharacters
    rows
  }
  createdAt
  isContentEmpty
  isDownloadAllowed
  requestHttpHeaders {
    name
    values
  }
  responseFailureReason
  responseHttpHeaders {
    name
    values
  }
  responsePrimaryIp
  responseStatusCode
  searchEngineActivity {
    lastVisit
    searchEngine
    status
  }
  url
}
    `;
export const RobotsTxtViewerScreenDocument = gql`
    query RobotsTxtViewerScreen($getRevisionById: Boolean!, $revisionId: ID!, $websiteId: WebsiteId!) {
  platformData(websiteId: $websiteId) {
    id
    canonicalRobotsTxtLegacyUrlId
  }
  latest: robotsTxtRevisionLatest(websiteId: $websiteId) {
    id
    isUnreliable
    lastUnreliableResponse
    unreliableSince
    ...Revision
  }
  byId: robotsTxtRevisionById(websiteId: $websiteId, revisionId: $revisionId) @include(if: $getRevisionById) {
    id
    ...Revision
  }
  list: robotsTxtRevisionsList(websiteId: $websiteId) {
    id
    createdAt
  }
}
    ${RevisionFragmentDoc}`;

/**
 * __useRobotsTxtViewerScreenQuery__
 *
 * To run a query within a React component, call `useRobotsTxtViewerScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useRobotsTxtViewerScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRobotsTxtViewerScreenQuery({
 *   variables: {
 *      getRevisionById: // value for 'getRevisionById'
 *      revisionId: // value for 'revisionId'
 *      websiteId: // value for 'websiteId'
 *   },
 * });
 */
export function useRobotsTxtViewerScreenQuery(baseOptions: Apollo.QueryHookOptions<RobotsTxtViewerScreenQuery, RobotsTxtViewerScreenQueryVariables> & ({ variables: RobotsTxtViewerScreenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RobotsTxtViewerScreenQuery, RobotsTxtViewerScreenQueryVariables>(RobotsTxtViewerScreenDocument, options);
      }
export function useRobotsTxtViewerScreenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RobotsTxtViewerScreenQuery, RobotsTxtViewerScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RobotsTxtViewerScreenQuery, RobotsTxtViewerScreenQueryVariables>(RobotsTxtViewerScreenDocument, options);
        }
export function useRobotsTxtViewerScreenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RobotsTxtViewerScreenQuery, RobotsTxtViewerScreenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RobotsTxtViewerScreenQuery, RobotsTxtViewerScreenQueryVariables>(RobotsTxtViewerScreenDocument, options);
        }
export type RobotsTxtViewerScreenQueryHookResult = ReturnType<typeof useRobotsTxtViewerScreenQuery>;
export type RobotsTxtViewerScreenLazyQueryHookResult = ReturnType<typeof useRobotsTxtViewerScreenLazyQuery>;
export type RobotsTxtViewerScreenSuspenseQueryHookResult = ReturnType<typeof useRobotsTxtViewerScreenSuspenseQuery>;
export type RobotsTxtViewerScreenQueryResult = Apollo.QueryResult<RobotsTxtViewerScreenQuery, RobotsTxtViewerScreenQueryVariables>;